// routes.js
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';


import BranchList from '../pages/branches/List';
import AddBranch from '../pages/branches/AddUpdate';
import BranchDetails from '../pages/branches/Details';

import CategoryList from '../pages/categories/List';
import AddCategory from '../pages/categories/AddUpdate';

import BannerList from '../pages/banners/List';
import AddBanner from '../pages/banners/AddUpdate';

import OrderList from '../pages/orders/List';
import OrderDetails from '../pages/orders/Details';

import SystemUserList from '../pages/system_users/List';
import AddSystemUser from '../pages/system_users/AddUpdate';

import RoleList from '../pages/roles/List';
import AddRole from '../pages/roles/AddUpdate';

import ItemList from '../pages/items/List';
import AddItem from '../pages/items/AddUpdate';
import ItemDetails from '../pages/items/Details';

import AddonList from '../pages/addons/List';
import AddAddon from '../pages/addons/AddUpdate';

import AddonItemList from '../pages/addon_items/List';
import AddAddonItem from '../pages/addon_items/AddUpdate';

import FlavorList from '../pages/flavors/List';
import AddFlavor from '../pages/flavors/AddUpdate';

import PromoCodeList from '../pages/promo_codes/List';
import AddPromoCode from '../pages/promo_codes/AddUpdate';
import PromoDetails from '../pages/promo_codes/Details';

import Account from '../pages/Account';
import UserList from '../pages/users/List';
import UserDetails from '../pages/users/Details';

import NotFound from '../pages/NotFound'; 
// import CheckoutForm from '../pages/CheckoutForm'; 
import Setting from '../pages/Setting';

import MenuReport from '../pages/reports/MenuReport';
import BranchReport from '../pages/reports/BranchReport';
import CustomerReport from '../pages/reports/CustomerReport';
import PromoReport from '../pages/reports/PromoReport';
import NewVsExistingCustomers from '../pages/reports/NewVsExistingCustomers';
import Transactions from '../pages/Transactions';
import CustomNotificationList from '../pages/custom_notifications/List';
import SendCustomNotification from '../pages/custom_notifications/Send';
import CustomNotificationDetails from '../pages/custom_notifications/Details';
import FoodicsLogs from '../pages/reports/FoodicsLogs';

const routes = [
    {
        path: '/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/login',
        component: Login,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        meta: { requiresAuth: false, hideHeader: true }
    },
  
    {
        path: '/branches',
        component: BranchList,
        meta: { requiresAuth: true , hideHeader: false,  permission:'list-branches' }
    },
    {
        path: '/branches/create/:id?',
        component: AddBranch,
        meta: { requiresAuth: true , hideHeader: false, permission:'create-branches' }
    },

    {
        path: '/branches/:id',
        component: BranchDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-branches'  }
    },

    {
        path: '/items',
        component: ItemList,
        meta: { requiresAuth: true , hideHeader: false, permission:'list-items' }
    },
    {
        path: '/items/create/:id?',
        component: AddItem,
        meta: { requiresAuth: true , hideHeader: false, permission:'create-items' }
    },
    {
        path: '/items/:id',
        component: ItemDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-items'  }
    },

    {
        path: '/addons',
        component: AddonList,
        meta: { requiresAuth: true , hideHeader: false, permission:'list-addons'  }
    },
    {
        path: '/addons/create/:id?',
        component: AddAddon,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-addons' }
    },
    {
        path: '/addon_items',
        component: AddonItemList,
        meta: { requiresAuth: true , hideHeader: false, permission:'list-addons'  }
    },
    {
        path: '/addon_items/create/:id?',
        component: AddAddonItem,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-addons' }
    },

    {
        path: '/flavors',
        component: FlavorList,
        meta: { requiresAuth: true , hideHeader: false, permission:'list-addons'  }
    },
    {
        path: '/flavors/create/:id?',
        component: AddFlavor,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-addons' }
    },

    {
        path: '/banners/',
        component: BannerList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-banners'  }
    },
    {
        path: '/banners/create/:id?',
        component: AddBanner,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-banners'  }
    },
  
    {
        path: '/categories/',
        component: CategoryList,
        meta: { requiresAuth: true , hideHeader: false  , permission:'list-categories'  }
    },
    {
        path: '/categories/create/:id?',
        component: AddCategory,
        meta: { requiresAuth: true , hideHeader: false  , permission:'create-categories'  }
    },


    {
        path: '/promo_codes/',
        component: PromoCodeList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-promos'  }
    },
    {
        path: '/promo_codes/create/:id?',
        component: AddPromoCode,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-promos'  }
    },
    {
        path: '/promo_codes/:id',
        component: PromoDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-promos'  }
    },
    {
        path: '/orders/',
        component: OrderList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-orders'  }
    },
    {
        path: '/orders/:id',
        component: OrderDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'detail-orders' }
    },

    {
        path: '/foodics-logs',
        component: FoodicsLogs,
        meta: { requiresAuth: true, hideHeader: false, permission: 'menu-report' }
    },
    {
        path: '/menu-report/',
        component: MenuReport,
        meta: { requiresAuth: true , hideHeader: false , permission:'menu-report'  }
    },
    {
        path: '/branch-report/',
        component: BranchReport,
        meta: { requiresAuth: true , hideHeader: false , permission:'branch-report'  }
    },
    {
        path: '/customer-report/',
        component: CustomerReport,
        meta: { requiresAuth: true , hideHeader: false , permission:'customer-report'  }
    },
    {
        path: '/promo-report/',
        component: PromoReport,
        meta: { requiresAuth: true , hideHeader: false , permission:'promo-report'  }
    },
    {
        path: '/new-vs-existing-customers/',
        component: NewVsExistingCustomers,
        meta: { requiresAuth: true , hideHeader: false , permission:'customer-report'  }
    },
    {
        path: '/transactions/',
        component: Transactions,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-orders'  }
    },
    {
        path: '/custom-notifications/',
        component: CustomNotificationList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-orders'  }
    },
    {
        path: '/custom-notifications/send',
        component: SendCustomNotification,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-orders'  }
    },
    {
        path: '/custom-notifications/:id',
        component: CustomNotificationDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-orders'  }
    },
    // {
    //     path: '/orders/:id',
    //     component: OrderDetails,
    //     meta: { requiresAuth: true , hideHeader: false , permission:'detail-orders' }
    // },


    {
        path: '/users/',
        component: UserList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-customers' }
    },
    {
        path: '/users/:id',
        component: UserDetails,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-customers' }
    },
   
    {
        path: '/system-users/',
        component: SystemUserList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-users'}
    },
    {
        path: '/system-users/create/:id?',
        component: AddSystemUser,
        meta: { requiresAuth: true , hideHeader: false , permission:'create-users'}
    },
    {
        path: '/roles/',
        component: RoleList,
        meta: { requiresAuth: true , hideHeader: false , permission:'list-roles'}
    },
    {
        path: '/roles/create/:id?',
        component: AddRole,
        meta: { requiresAuth: true , hideHeader: false, permission:'create-roles' }
    },
    {
        path: '/account/',
        component: Account,
        meta: { requiresAuth: true , hideHeader: false }
    },
    {
        path: '/settings/',
        component: Setting,
        meta: { requiresAuth: true , hideHeader: false, permission:'list-settings'  }
    },

    {
        path: '*',
        component: NotFound,
        meta: { requiresAuth: true , hideHeader: false }
    },
];

export default routes;
